import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import mixins from "@/mixins";
import SnackbarQueue from 'vuejs-snackbar-queue'
import VueSSE from "vue-sse";

import "@/assets/styles/main.css";

Vue.config.productionTip = false;

Vue.use(SnackbarQueue)
Vue.use(VueSSE);
Vue.mixin(mixins);

new Vue({
  router,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
